import { API_URL, LEGAL_COMPLIANCE_INFORMATION_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${LEGAL_COMPLIANCE_INFORMATION_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchLegalComplianceInformation = async (lang: string) => {
  try {
    const legalComplianceInformationResponse = await fetchWithAuth(
      `${API_URL}/legal-compliance-information?populate=DisclaimerCopyrights,PoliciesStatements,Sitemap.Category,NStatement,FairUsePolicy,DisclaimerCopyrightsSEO.MetaImage,DisclaimerCopyrightsGA,PoliciesStatementsSEO.MetaImage,PoliciesStatementsGA,SitemapSEO.MetaImage,SitemapGA,NStatementSEO.MetaImage,NStatementGA,FairUsePolicySEO.MetaImage,FairUsePolicyGA&pagination[limit]=-1`,
      lang
    );

    const legalComplianceInformation = legalComplianceInformationResponse.data;

    console.log('fetchLegalComplianceInformation API Response:', legalComplianceInformation);
    return legalComplianceInformation;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};

export const fetchTermAndConditionsTitle = async (lang: string) => {
  try {
    const termAndConditionsTitleResponse = await fetchWithAuth(
      `${API_URL}/legal-compliance-information?populate[TermsConditions][populate][Tabs][fields][0]=Title&pagination[limit]=-1`,
      lang
    );

    const termAndConditionsTitle = termAndConditionsTitleResponse.data;

    console.log('fetchTermAndConditionsTitle API Response:', termAndConditionsTitle);
    return termAndConditionsTitle;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};

export const fetchTermAndConditionsSEOAndGA = async (lang: string) => {
  try {
    const termAndConditionsSEOAndGAResponse = await fetchWithAuth(
      `${API_URL}/legal-compliance-information?populate=TermsConditionsSEO.MetaImage,TermsConditionsGA&pagination[limit]=-1`,
      lang
    );

    const termAndConditionsSEOAndGA = termAndConditionsSEOAndGAResponse.data;

    console.log('fetchTermAndConditionsSEOAndGA API Response:', termAndConditionsSEOAndGA);
    return termAndConditionsSEOAndGA;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};

export const fetchTermAndConditionsById = async (lang: string,id: string) => {
  try {
    const termAndConditionsByIdResponse = await fetchWithAuth(
      `${API_URL}/legal-compliance-information?populate[TermsConditions][populate][Tabs][filters][id][$eq]=${id}`,lang
    );

    const termAndConditionsById = termAndConditionsByIdResponse.data;

    console.log('fetchTermAndConditionsById API Response:', termAndConditionsById);
    return termAndConditionsById;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};